<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/libraries/EventBus";

export default {
    name: "DefaultMenu",
    computed: {
        ...mapGetters("auth", [
            "getAuthUser",
            "getMyId",
            "getIsAdmin",
            "getAclMap",
            "getAclRole"
        ])
    },
    methods: {
        async doLogout() {
            await this.$store.dispatch("auth/logout");
            this.$router.push("/login");
        },
        clock() {
            EventBus.$emit("register-daylog");
        },
        isAdmin() {
            if (this.getAclRole === "ROOT") {
                return true;
            } else {
                return false;
            }
        },
        isLeader() {
            if (this.getAclRole === "LEADER" || this.getAclRole === "ROOT") {
                return true;
            } else {
                return false;
            }
        }
    }
};
</script>

<template>
    <side-bar>
        <template slot="links">
            <!-- reg -->
            <sidebar-item
                :link="{
                    name: $t('menu.registration'),
                    icon: 'far fa-cabinet-filing'
                }"
                :force-navigation="{ name: 'StartDashboard' }"
            >
                <sidebar-item
                    :link="{
                        name: $t('menu.my_cases_overview'),
                        path: '/projects/my-overview'
                    }"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.all_cases'),
                        path: '/projects/index'
                    }"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.my_tasks'),
                        icon: 'far fa-tasks',
                        path: '/tasks/my-tasks'
                    }"
                    v-if="true"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.my_travels'),
                        icon: 'far fa-cars',
                        path: '/travels/my-travels'
                    }"
                    v-if="true"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.my_hours'),
                        icon: 'far fa-hourglass',
                        path: '/reports/my-hours'
                    }"
                    v-if="true"
                />
            </sidebar-item>

            <!-- dev -->
            <sidebar-item
                :link="{
                    name: $t('menu.development'),
                    icon: 'far fa-calendar-alt'
                }"
            >
                <sidebar-item
                    :link="{
                        name: $t('menu.planning_portfolio'),
                        path: '/projects/portfolio'
                    }"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.projects_my_projects'),
                        path: '/projects/portfolio?preset=mine'
                    }"
                    v-if="false"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.planning_report'),
                        path: '/projects/planning-report'
                    }"
                />
                <sidebar-item
                    v-if="getMyId == 83"
                    :link="{
                        name: $t('menu.land_leases'),
                        path: '/land-leases/index'
                    }"
                />

                <sidebar-item
                    :link="{
                        name: $t('menu.data_exports'),
                        path: '/reports/projects-reports'
                    }"
                    v-if="$aclCan($ACL.CUSTOM_PLANNING_EXP_DEVMODEL)"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.import_project_budgets'),
                        path: '/projects/import-budgets'
                    }"
                    v-if="
                        $aclCan($ACL.CUSTOM_PLANNING_IMPORT_BUDGETS || isAdmin)
                    "
                />
            </sidebar-item>

            <!-- MFAs -->
            <sidebar-item
                v-if="$aclCan($ACL.CUSTOM_PLANNING_MFA)"
                :link="{
                    name: $t('menu.mfas'),
                    icon: 'far fa-badge-check'
                }"
            >
                <sidebar-item
                    :link="{
                        name: $t('menu.mfa_flags'),
                        path: '/project-flags/index'
                    }"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.mfa_status'),
                        path: '/project-flags/status-mfa'
                    }"
                />
            </sidebar-item>

            <!-- Own assets -->
            <sidebar-item
                :link="{
                    name: $t('menu.own_assets'),
                    path: $aclCan($ACL.CUSTOM_FULL_MB)
                        ? '/reports/mb-report/dk-assets-full'
                        : '/reports/mb-report/dk-assets',
                    icon: 'far fa-wind-turbine'
                }"
            />
            <sidebar-item
                :link="{
                    name: $t('menu.statistics'),
                    path: '/reports/mb-report/spot-prices',
                    icon: 'far fa-chart-pie'
                }"
            />

            <!-- Bookkeeping -->
            <sidebar-item
                :link="{ name: $t('menu.bookkeepers'), icon: 'far fa-book' }"
                :hide-mobile="true"
                v-if="isAdmin()"
            >
                <sidebar-item
                    :link="{
                        name: $t('menu.travel_viewer'),
                        icon: 'far fa-tasks',
                        path: '/travels/index'
                    }"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.travel_salary'),
                        icon: 'far fa-tasks',
                        path: '/travels/salary'
                    }"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.travel_salary_reports'),
                        icon: 'far fa-tasks',
                        path: '/travels/salary-reports'
                    }"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.global_inbox'),
                        path: '/vouchers/inbox'
                    }"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.global_booked_costs'),
                        path: '/vouchers/index'
                    }"
                />

                <sidebar-item
                    :link="{
                        name: $t('menu.economic_connections'),
                        path: '/ec-connections'
                    }"
                />
            </sidebar-item>

            <!-- Settings -->
            <sidebar-item
                :link="{
                    name: $t('menu.administration'),
                    icon: 'far fa-cogs',
                    path: '/settings'
                }"
                v-if="isAdmin()"
            >
                <sidebar-item
                    :link="{
                        name: $t('menu.activities'),
                        path: '/settings/activities'
                    }"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.milestones'),
                        path: '/settings/milestones'
                    }"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.role_prices'),
                        path: '/settings/role-prices'
                    }"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.travel_prices'),
                        path: '/travel-prices'
                    }"
                />
                <sidebar-item
                    :link="{ name: $t('menu.users'), path: '/users/index' }"
                    :hide-mobile="true"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.departments'),
                        path: '/departments/index'
                    }"
                    :hide-mobile="true"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.reopen_day'),
                        icon: 'far fa-tasks',
                        path: '/projects/reopen'
                    }"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.currencies'),
                        path: '/contracts/currencies'
                    }"
                    :hide-mobile="true"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.netto_price_index'),
                        path: '/contracts/netprices'
                    }"
                    :hide-mobile="true"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.asset_categories'),
                        path: '/contracts/asset-groups'
                    }"
                    :hide-mobile="true"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.contract_products'),
                        path: '/contracts/products'
                    }"
                    :hide-mobile="true"
                />
                <template v-if="$TENANT === 'dk'">
                    <sidebar-item
                        :link="{
                            name: $t('menu.import_customers'),
                            path: '/customers/import'
                        }"
                        :hide-mobile="true"
                    />
                </template>
            </sidebar-item>

            <sidebar-item
                :link="{ name: $t('menu.reports'), icon: 'far fa-chart-pie' }"
                :hide-mobile="true"
                v-if="isLeader()"
            >
                <sidebar-item
                    :link="{
                        name: $t('menu.all_customers'),
                        path: '/customers/index'
                    }"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.all_tasks'),
                        icon: 'far fa-tasks',
                        path: '/tasks/index'
                    }"
                />

                <sidebar-item
                    :link="{
                        name: $t('menu.all_cases_overview'),
                        icon: 'far fa-tasks',
                        path: '/projects/full-overview'
                    }"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.projects_invoicing_report'),
                        icon: 'far fa-tasks',
                        path: '/projects/invoicing-report'
                    }"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.hour_report'),
                        path: '/reports/activities'
                    }"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.absence'),
                        path: '/reports/absence'
                    }"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.cases'),
                        path: '/reports/projects'
                    }"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.cases_performance'),
                        path: '/reports/projects-performance'
                    }"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.open_days'),
                        path: '/reports/open-days'
                    }"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.contract_reports'),
                        path: '/reports/contracts'
                    }"
                    :hide-mobile="true"
                />
                <sidebar-item
                    :link="{
                        name: $t('menu.personal_multiview'),
                        path: '/reports/personal-multiview'
                    }"
                    :hide-mobile="true"
                />
                <sidebar-item
                    :link="{ name: $t('menu.budget'), path: '/reports/budget' }"
                    :hide-mobile="true"
                />
                <sidebar-item
                    v-if="isAdmin"
                    :link="{
                        name: $t('menu.utilization_factor_report'),
                        path: '/reports/utilization-factor'
                    }"
                    :hide-mobile="true"
                />
            </sidebar-item>

            <sidebar-item
                :link="{
                    name: $t('menu.help'),
                    icon: 'far fa-question-circle',
                    path: '/help'
                }"
            >
            </sidebar-item>

            <a class="nav-link" href="#" @click.prevent="doLogout">
                <i class="far fa-sign-out"></i>
                <span class="nav-link-text">{{ $t("menu.logout") }}</span>
            </a>
        </template>
    </side-bar>
</template>

<style lang="scss">
#menu-switcher {
    display: flex;
    justify-content: space-around;
    margin-left: 8px;
    margin-right: 8px;
    button {
        background: transparent;
        font-size: 10px;
        height: 25px;
        padding: 0px;
        margin: 0px;
    }
}
</style>
